import { atom } from 'jotai';
import { atomWithQuery } from 'jotai-tanstack-query';
import { captureException, fetchAllData } from 'r/utils';
import { GET_PAIRS } from 'r/utils/fetchApiRaw';
import type { CryptoPair } from 'r/types';

export const pairsAtom = atomWithQuery(() => ({
  queryKey: ['crypto-pairs'],
  queryFn: async () => {
    try {
      const { data: pairs } = await fetchAllData(GET_PAIRS, {
        queryParams: {
          attributes: '"symbol","quote","slug","logoUrl","source"',
          noNeedInclude: true,
        },
      });
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore:next-line
      return pairs.map((pair: CryptoPair) => ({
        ...pair,
        metric: `price_${pair.quote.toLowerCase()}`,
      }));
    } catch (e) {
      captureException(e);
      throw e;
    }
  },
  staleTime: 30 * 60 * 1000,
  gcTime: 60 * 60 * 1000,
  refetchOnWindowFocus: false,
}));

export const hlPairsAtom = atomWithQuery(() => ({
  queryKey: ['crypto-pairs-hyperliquid'],
  queryFn: async () => {
    try {
      const { data: pairs } = await fetchAllData(GET_PAIRS, {
        queryParams: {
          filter: '"source":"hyperliquid"',
          noNeedInclude: true,
        },
      });
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore:next-line
      return (pairs as CryptoPair[])
        .map((pair) => ({
          ...pair,
          metric: `price_${pair.quote.toLowerCase()}`,
        }))
        .sort((a, b) => a.symbol.localeCompare(b.symbol));
    } catch (e) {
      captureException(e);
      throw e;
    }
  },
  staleTime: 30 * 60 * 1000,
  gcTime: 60 * 60 * 1000,
  refetchOnWindowFocus: false,
}));

export const hlFilteredPairsAtom = atom((get) => {
  const query = get(hlPairsAtom);
  return query.data ?? [];
});
